import { IGetChecklistServicoByIdUseCase } from "../../../presentation/useCases/read/get_checklist_servico_by_id_use_case";
import { ChecklistServicoDetalhe } from "../../models/checklist_servico_detalhe";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetChecklistServicoByIdUseCase
 */

export class GetChecklistServicoByIdUseCase implements IGetChecklistServicoByIdUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getChecklistServicoById(
    idChecklistServico: number | undefined,
  ): Promise<ChecklistServicoDetalhe> {
    if (idChecklistServico === undefined) throw new Error("Falha ao obter id de checklist de serviço!");

    const response = await this.repository.getChecklistServicoById(
      idChecklistServico,
    );

    if (response === null) throw new Error("Falha ao obter checklist de serviço!");

    return response;
  }
}
